"use strict";

function match(obj, key, value) {
  var val = obj[key];

  if (!val) {
    throw new Error("".concat(key, " returned undefined"));
  }

  var comparator; // we can specify a regular expression in the options with regexp:/<grp1>/<grp2>

  if (String(value).match(/regexp:\/(.*)\/([a-z]*)/)) {
    var matcher = String(value).match(/regexp:\/(.*)\/([a-z]*)/);
    var grp1 = matcher[1];
    var grp2 = matcher[2];
    comparator = new RegExp(grp1, grp2);
  } else {
    comparator = value;
  }

  var matches = Boolean(val.match(comparator));
  return matches;
}

module.exports = match;